/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TableRowVisibilityLeafConditionDto } from './TableRowVisibilityLeafConditionDto';
import {
    TableRowVisibilityLeafConditionDtoFromJSON,
    TableRowVisibilityLeafConditionDtoFromJSONTyped,
    TableRowVisibilityLeafConditionDtoToJSON,
    TableRowVisibilityLeafConditionDtoToJSONTyped,
} from './TableRowVisibilityLeafConditionDto';

/**
 * Per-row cell visibility condition, evaluated against other columns in the same table. `conditions` holds one leaf per referenced column — even a single condition is a one-entry list — combined via `groupOperator`.
 * @export
 * @interface TableRowVisibilityConditionDto
 */
export interface TableRowVisibilityConditionDto {
    /**
     * Combines the entries in `conditions`. Defaults to AND when unset.
     * @type {string}
     * @memberof TableRowVisibilityConditionDto
     */
    groupOperator?: TableRowVisibilityConditionDtoGroupOperatorEnum | null;
    /**
     * One leaf condition per referenced column.
     * @type {Array<TableRowVisibilityLeafConditionDto>}
     * @memberof TableRowVisibilityConditionDto
     */
    conditions?: Array<TableRowVisibilityLeafConditionDto> | null;
}


/**
 * @export
 */
export const TableRowVisibilityConditionDtoGroupOperatorEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type TableRowVisibilityConditionDtoGroupOperatorEnum = typeof TableRowVisibilityConditionDtoGroupOperatorEnum[keyof typeof TableRowVisibilityConditionDtoGroupOperatorEnum];


/**
 * Check if a given object implements the TableRowVisibilityConditionDto interface.
 */
export function instanceOfTableRowVisibilityConditionDto(value: object): value is TableRowVisibilityConditionDto {
    return true;
}

export function TableRowVisibilityConditionDtoFromJSON(json: any): TableRowVisibilityConditionDto {
    return TableRowVisibilityConditionDtoFromJSONTyped(json, false);
}

export function TableRowVisibilityConditionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableRowVisibilityConditionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'groupOperator': json['groupOperator'] == null ? undefined : json['groupOperator'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(TableRowVisibilityLeafConditionDtoFromJSON)),
    };
}

export function TableRowVisibilityConditionDtoToJSON(json: any): TableRowVisibilityConditionDto {
    return TableRowVisibilityConditionDtoToJSONTyped(json, false);
}

export function TableRowVisibilityConditionDtoToJSONTyped(value?: TableRowVisibilityConditionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupOperator': value['groupOperator'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(TableRowVisibilityLeafConditionDtoToJSON)),
    };
}

